var _circle, _g, _rect, _rect2, _g2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameChangeAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 142,
    viewBox: "0 0 147 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.759,
    cy: 75.759,
    r: 65.759,
    fill: "#E6F6FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1590_345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 34,
    width: 133,
    height: 83,
    rx: 1.59127,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2747,
    y: 44.9563,
    width: 39.1452,
    height: 43.6007,
    rx: 0.954761,
    fill: "#E6F6FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1590_345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 44,
    width: 40,
    height: 45
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2747,
    y: 44.9563,
    width: 39.1452,
    height: 43.6007,
    rx: 0.954761,
    fill: "#E6F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1590_345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1477 78.6824C40.1784 80.4979 43.1562 81.3751 44.554 81.017C48.0592 80.1191 48.3814 67.3752 45.6693 62.3512C42.9573 57.3272 29.0149 55.1374 28.3121 65.0916C28.0682 68.5464 29.5278 71.6295 31.6844 74.1454L27.8175 92.0578H39.05L37.1477 78.6824Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.415 61.778C23.0522 61.4207 22.8543 60.9107 22.6831 60.4264C22.5054 59.9234 22.3326 59.4151 22.2146 58.8915C21.9787 57.8453 21.9765 56.6422 22.7275 55.8298C23.3297 55.1783 24.2334 54.8862 25.0674 54.8227C25.6231 54.7803 26.1938 54.8576 26.7264 55.0317C27.2549 55.2043 27.7105 55.5484 28.2228 55.7619C28.2423 54.6345 28.4367 53.4548 29.0122 52.4922C29.566 51.5659 30.4489 51.0462 31.4545 50.9086C32.4866 50.7675 33.5058 51.0076 34.4297 51.5041C34.6611 51.6285 34.8902 51.7588 35.1095 51.9062C35.2932 52.0297 35.4841 52.1784 35.6996 52.2287C35.9398 52.2847 36.0588 52.1468 36.2149 51.9727C36.398 51.7685 36.6042 51.5886 36.8224 51.4292C37.7874 50.7242 39.0534 50.4344 40.1713 50.8569C40.6864 51.0516 41.1873 51.3822 41.5367 51.8378C41.8482 52.2439 42.0704 52.8881 42.5003 53.171C42.6827 53.2911 42.8116 53.132 42.9777 53.0144C43.2272 52.8377 43.4651 52.6427 43.7177 52.4708C44.0724 52.2293 44.4564 52.0486 44.8677 51.9541C45.4697 51.8156 46.3017 51.8481 46.4739 52.6318C46.5385 52.9261 46.4889 53.2409 46.468 53.5375C46.4394 53.9448 46.4095 54.3519 46.3739 54.7585C46.3469 55.0673 46.3127 55.3655 46.2541 55.6687C46.2228 55.8303 46.125 56.1317 46.1947 56.2935C46.2819 56.4958 46.6841 56.3808 46.8559 56.3878C47.1953 56.4018 47.5361 56.4609 47.85 56.6051C48.0932 56.7168 48.3489 56.8811 48.4515 57.1581C48.5146 57.3283 48.498 57.5031 48.4682 57.6782C48.4325 57.8884 48.4733 57.9998 48.5 58.2118C48.9559 57.9888 50.5355 57.4931 50.7343 58.305C50.8005 58.5754 50.6498 58.8808 50.5348 59.1088C50.3332 59.5087 50.0688 59.8742 49.7985 60.2228C49.2348 60.95 48.5617 61.5772 47.8376 62.1135C48.686 62.4884 48.9075 63.5941 48.1729 64.2528C47.8486 64.5437 47.4125 64.6084 47.0034 64.5898C46.8537 64.583 46.6378 64.5258 46.52 64.5517C46.4566 64.5657 46.3887 64.6191 46.3009 64.6251C45.7235 64.6644 45.0717 64.5261 44.5073 64.3988C43.5016 64.1719 42.5495 63.6984 41.772 62.9772C41.5726 62.7922 41.4078 62.6857 41.1393 62.6884C40.9041 62.6908 40.6733 62.7549 40.4383 62.7608C39.8164 62.7766 39.2557 62.4744 38.6782 62.2733C38.6429 63.0486 38.4207 63.9025 38.1016 64.6C37.8414 65.1688 37.298 65.2515 36.764 65.3014C35.0564 65.461 33.3428 65.2828 31.633 65.2852C33.2881 65.657 34.9984 65.8103 36.6387 66.2478C37.3802 66.4455 36.814 66.9422 36.497 67.2865C35.9749 67.8535 35.5867 68.556 35.3175 69.296C34.5079 68.2472 33.0768 67.556 31.8089 67.8783C30.4081 68.2342 29.4216 70.117 30.3174 71.4706C30.8375 72.2564 31.7767 72.5597 32.5581 72.8973C31.9485 73.5272 31.8011 74.4576 31.4341 75.2413C31.2531 75.6278 30.9991 76.0647 30.5944 76.1994C30.4447 76.2493 30.2691 76.2535 30.151 76.3748C30.0046 76.525 29.9698 76.6929 29.7829 76.822C29.0372 77.3373 27.8725 77.2975 27.2115 76.6252C26.6138 76.0171 26.7693 75.0548 27.2685 74.4383C26.4739 74.1092 25.0263 73.6858 25.3421 72.4555C23.6202 72.3419 19.4397 69.5666 21.7507 67.5386C20.4824 66.8262 19.3173 65.0853 20.1319 63.5507C20.7592 62.3689 22.2181 61.8407 23.415 61.778Z",
    fill: "black"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.1936,
    y: 52.2762,
    width: 70.0871,
    height: 3.15708,
    rx: 1.57854,
    fill: "#005F8D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.1936,
    y: 60.4843,
    width: 51.1446,
    height: 3.15708,
    rx: 1.57854,
    fill: "#005F8D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.1936,
    y: 78.744,
    width: 22.0995,
    height: 3.15708,
    rx: 1.57854,
    fill: "#005F8D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.6641,
    y: 75.4844,
    width: 19.1338,
    height: 3.18897,
    rx: 1.59448,
    fill: "#00A6CA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106.987,
    y: 75.4844,
    width: 19.1338,
    height: 3.18897,
    rx: 1.59448,
    fill: "#00A6CA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9563,
    y: 95.9221,
    width: 51.776,
    height: 3.15708,
    rx: 1.57854,
    fill: "#005F8D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9407,
    y: 95.9221,
    width: 46.0933,
    height: 3.15708,
    rx: 1.57854,
    fill: "#005F8D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9563,
    y: 104.131,
    width: 112.392,
    height: 3.15708,
    rx: 1.57854,
    fill: "#005F8D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1590_345)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.0765,
    cy: 24.0765,
    r: 16.0765,
    fill: "#67D995"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1590_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6312 23.7215H24.4906C24.4906 21.1371 25.4929 18.7073 27.3122 16.8803C29.1329 15.0533 31.5511 14.0468 34.1246 14.0468C36.6981 14.0468 39.1177 15.0533 40.937 16.8803L40.13 17.6907C38.526 16.0799 36.393 15.1922 34.1246 15.1922C31.8562 15.1922 29.7232 16.0799 28.1192 17.6907C26.5152 19.3015 25.6312 21.4435 25.6312 23.7215Z",
    fill: "#185230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1246 33.3963C31.5511 33.3963 29.1316 32.3898 27.3123 30.5628L28.1192 29.7524C29.7233 31.3632 31.8562 32.2509 34.1246 32.2509C36.3931 32.2509 38.526 31.3632 40.13 29.7524C41.734 28.1416 42.618 25.9996 42.618 23.7216H43.7587C43.7587 26.306 42.7563 28.7358 40.937 30.5628C39.1177 32.3898 36.6982 33.3963 34.1246 33.3963Z",
    fill: "#185230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4125 26.7642L43.1883 24.5305L40.9641 26.7642L40.1571 25.9538L42.7848 23.3149C43.0072 23.0916 43.3694 23.0916 43.5918 23.3149L46.2195 25.9538L45.4125 26.7642Z",
    fill: "#185230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0609 24.2943C24.9098 24.2943 24.7644 24.2342 24.6574 24.1268L22.0311 21.4879L22.8381 20.6775L25.0623 22.9112L27.2866 20.6775L28.0936 21.4879L25.4658 24.1268C25.3589 24.2342 25.2135 24.2943 25.0623 24.2943H25.0609Z",
    fill: "#185230"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1590_345",
    x: 0.634929,
    y: 27.6349,
    width: 145.73,
    height: 95.7301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.18254
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1590_345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1590_345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1590_345",
    x: 10.5226,
    y: 0.522562,
    width: 47.1078,
    height: 47.1079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.73872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1590_345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1590_345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1590_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.187,
    height: 19.3496,
    fill: "white",
    transform: "translate(22.0311 14.0468)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameChangeAlert);
export default __webpack_public_path__ + "static/media/name_change_alert.9d989bd1fcfd89ade6d37f5be7caab70.svg";
export { ForwardRef as ReactComponent };